import auth from "./src/auth";
import authPage from "./src/authPage";
const Auth = auth;
const AuthPage = authPage;

export { Auth, AuthPage };
